import { Flex, Text, toast } from '@approvalmax/ui/src/components';
import { ui } from 'modules/common';
import { memo, useEffect } from 'react';

import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';
import { SelectTime } from '../SelectTime/SelectTime';
import { useTimeOptionSelect, useWeekdayOptionSelect } from './CustomWeeklyScheduleOption.hooks';
import { messages } from './CustomWeeklyScheduleOption.messages';
import { CustomWeeklyScheduleOptionProps } from './CustomWeeklyScheduleOption.types';

export const CustomWeeklyScheduleOption = memo<CustomWeeklyScheduleOptionProps>((props) => {
    const { ruleIndex } = props;

    const { schedule } = useReportSchedulerContext();

    const { value: valueDay, handleChange: handleChangeDay } = useWeekdayOptionSelect(ruleIndex);
    const { value: valueTime, handleChange: handleChangeTime } = useTimeOptionSelect(ruleIndex);

    const {
        validationErrors: { weekError },
    } = schedule.rules[ruleIndex];

    useEffect(() => {
        if (weekError) {
            toast.error(weekError);
        }
    }, [weekError]);

    return (
        <Flex alignItems='center' spacing='8' wrap={false} data-qa='custom-weekly-schedule'>
            <Text font='label' color='midnight70' fontSize='small'>
                {messages.everyText}
            </Text>

            <ui.WeekPickerEditor value={valueDay} onChange={handleChangeDay} />

            <Text font='label' color='midnight70' fontSize='small'>
                {messages.timeLabel}
            </Text>

            <div>
                <SelectTime time={valueTime} onChange={handleChangeTime} />
            </div>
        </Flex>
    );
});

CustomWeeklyScheduleOption.displayName = 'CustomWeeklyScheduleOption';
